import { render, staticRenderFns } from "./ProfileLabalaguereTransactions.vue?vue&type=template&id=119f588e"
import script from "./ProfileLabalaguereTransactions.vue?vue&type=script&lang=js"
export * from "./ProfileLabalaguereTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports